import React, { useState, createRef } from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import HairlineDivider from '@tds/core-hairline-divider';

import Logo from './logo';
import Menu from './menu';
import Admin from './admin';
import AccountInfo from './AccountInfo';

const Header = ({ locale, userName, userRights }) => {
  const [showAccountInfo, setShowAccountInfo] = useState(false);

  const ref = createRef();
  const onClick = (e, className) => {
    e.preventDefault();
    ref.current.className = className;
  };

  return (
    <>
      <header id="header">
        <div className="header-main">
          <div className="nav-main">
            <div className="nav-inner">
              <ul>{userRights && <Admin userRights={userRights} />}</ul>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  flex: '1 1 0%'
                }}
              >
                <ul>
                  {userName && (
                    <Menu
                      locale={locale}
                      userName={userName}
                      userRights={userRights}
                    />
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="header-bottom-main">
          <div className="header-bottom-container">
            <div className="header-bottom-inner">
              <Logo locale={locale} userRights={userRights} />
              {userName && (
                <div className="header-bottom-username-main">
                  <span className="header-bottom-welcome-label">Welcome</span>
                  <button
                    style={{
                      background: 'transparent',
                      border: 0,
                      textDecoration: 'underline',
                      padding: 0
                    }}
                    type="button"
                    className="header-bottom-username"
                    onClick={() => setShowAccountInfo(true)}
                  >
                    {userName}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      {userName && (
        <>
          <a
            href="#navPanelToggle"
            className="navPanelToggle"
            onClick={e => onClick(e, 'visible')}
          >
            <span className="fa fa-bars"></span>
          </a>

          <div id="navPanel" ref={ref}>
            <Menu locale={locale} userName={userName} userRights={userRights} />
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a
              href="#navPanel"
              className="close"
              onClick={e => onClick(e, '')}
            />
          </div>
        </>
      )}
      <Box between={4}>
        <HairlineDivider />
        <HairlineDivider gradient />
      </Box>
      <section id="banner" />
      {showAccountInfo && (
        <AccountInfo
          onClose={() => {
            setShowAccountInfo(false);
          }}
        />
      )}
    </>
  );
};

Header.propTypes = {
  locale: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  userRights: PropTypes.shape({
    isStatusEditable: PropTypes.bool,
    isUserEditable: PropTypes.bool,
    canAssignOrder: PropTypes.bool,
    isAdminBandVisible: PropTypes.bool,
    isUserPageVisible: PropTypes.bool,
    isSOVDashboardVisible: PropTypes.bool,
    isQuoteApprovalDashboardVisible: PropTypes.bool,
    isBulkUploadVisible: PropTypes.bool
  })
};

Header.defaultProps = {
  userRights: null
};

export default Header;
